module.exports = __webpack_public_path__ + "078a5b9b7546c177fff19fc6ded1ce99.png";